import {User, Customer} from '../model/shared/user/user';
import {BaseResponse} from './internal/baseresponse';

export class UserDetailResult extends BaseResponse {
  data: Customer;
}



// WEBPACK FOOTER //
// ./src/app/response/userdetailresult.ts